import React from 'react';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useMutation } from 'react-fetching-library';
import { Modal, Card, CardContent, Stack, Button, Portal, Typography, TextField, Alert } from '@mui/material';

import { createJsonFormNewVersionAction } from '../../services/request';

const validationSchema = Yup.object({
  version: Yup.number().required('To pole nie może być puste'),
  description: Yup.string()
});

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
};

const getNextVersion = (form, forms) => {
  const sameIdentifierVersions = forms
    .filter(item => item.identifier === form.identifier)
    .map(item => Number(item.version));
  const latestVersion = sameIdentifierVersions.length > 0 ? Math.max(...sameIdentifierVersions) : Number(form.version);

  return latestVersion + 1;
};

export default function JsonFormNewVersion ({ open, setOpen, setForms, form, forms }) {
  const { mutate, error, reset } = useMutation(createJsonFormNewVersionAction);

  const handleSubmit = async values => {
    const { error, payload } = await mutate(form.id, values);

    if (!error) {
      setForms(prev => [payload, ...prev]);
      reset();
      formik.resetForm();
      setOpen(false);
    }
  };

  const formik = useFormik({
    initialValues: {
      version: getNextVersion(form, forms),
      description: form.description
    },
    validateOnChange: false,
    validationSchema,
    onSubmit: handleSubmit
  });

  return (
    <Portal>
      <Modal open={open} onClose={() => setOpen(false)}>
        <Card sx={{ ...style, width: '30vw' }}>
          <CardContent>
            <form onSubmit={formik.handleSubmit}>
              <Typography variant="subtitle1" sx={{ mb: 2 }}>Nowa wersja formularza: {form.identifier}</Typography>
              <Stack spacing={3}>
                <TextField
                  id="version"
                  size="small"
                  label="Wersja"
                  type="number"
                  fullWidth
                  value={formik.values.version}
                  onChange={formik.handleChange}
                  error={formik.errors.version && formik.touched.version}
                  helperText={formik.errors.version}
                />
                <TextField
                  id="description"
                  size="small"
                  label="opis"
                  multiline
                  maxRows={3}
                  fullWidth
                  value={formik.values.description}
                  onChange={formik.handleChange}
                />
              </Stack>
              { error
                ? <Alert variant="outlined" severity="error" sx={{ mt: 4 }}>Wystąpił błąd. Upewnij się czy identyfikator z taką wersją nie jest już utworzony.</Alert>
                : null}
              <Stack direction="row" sx={{ mt: 4 }} spacing={5}>
                <Button variant="outlined" sx={{ width: '100%' }} onClick={() => setOpen(false)}>Anuluj</Button>
                <Button variant="contained" sx={{ width: '100%' }} type="submit">Dodaj</Button>
              </Stack>
            </form>
          </CardContent>
        </Card>
      </Modal>
    </Portal>
  );
};
